<template>
    <div class="workorderInfromation">
        <div class="workorderInfromation_title">
            <!--<div class="workorderInfromation_t_zhzx" :class="{'QZX':timeLineData.roleGrade=='1','ZLD':timeLineData.roleGrade=='2','ZGLD':timeLineData.roleGrade=='4','ZX':timeLineData.roleGrade=='3'}">-->
                <!--{{timeLineData.czCzdwmc}}-->
            <!--</div>-->
            <div class="workorderInfromation_t_zhzx ZX" v-if="timeLineData.czCzjskey=='WGSJ_ZX'">
                指挥中心
            </div>
            <div class="workorderInfromation_t_describe QZX">
                {{timeLineData.czCzrmc}}
            </div>
            <div class="workorderInfromation_t_describe">
                合格检查
            </div>
            <div class="workorderInfromation_t_pass" v-if="timeLineData.czCzjgzt=='1'">
                通过
            </div>
            <div class="workorderInfromation_t_reject" v-else>
                驳回
            </div>
        </div>
        <div class="workorderInfromation_progressTime">
            <span class="icon-time_fill workorderInfromation_icon"></span>
            <div class="workorderInfromation_p_time">
                {{timeLineData.czCzsj}}
            </div>
            <div class="workorderInfromation_p_day">
                第{{timeLineData.theDay}}天
            </div>
        </div>
        <div class="workorderInfromation_option">
            <span class="icon-progress workorderInfromation_icon"></span>
            <div>
                {{timeLineData.czCzjgwb}}
            </div>
        </div>
    </div>
</template>

<script>
    import {reactive, ref, getCurrentInstance, onMounted, inject} from 'vue';
    import TimeLine_file from "./TimeLine_file.vue"
    export default {
        name: "returnvisitInformation",
        props:["timeLineList"],
        components: {
            TimeLine_file
        },
        setup(props, context) {
            // let timeLineData = reactive({
            //     "czCzdwmc": "指挥中心",//处置单位名称
            //     "czCzrmc": "张倩",  //处置人名称
            //     "czCzsj": "2021.12.02 14:11:38", //处置时间
            //     "czCzjgwb": "开发区商务金融。",
            //     "theDay": "1", //第n天"
            //     "czCzjgzt": "1",     //审核状态（1通过0驳回）
            //     "czSfjj": "0",               //是否解决(1是、0否)
            //     "czSfmy": "1",              //是否满意(1是、0否)
            //     "formKey": 8,
            // })
            let timeLineData = props.timeLineList;
            return {
                timeLineData
            }
        }
    }
</script>

<style scoped>

</style>
